import type {
  CreateObservationRequest,
  CreateVitalsResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ObservationApi {
  public async createObservationVital(
    params: CreateObservationRequest,
  ): Promise<CreateVitalsResponse> {
    return await trpcClient.patient.createObservation.mutate({
      ...params,
    });
  }
}
